import { Messages } from "../../lib/locale";

export const Hungarian: Messages = {
  name: "Magyar",
  helpTitle: "Hogyan kell játszani",
  help1: `Az Ön feladata, hogy megtudja, melyik ország van elrejtve a játékban. Ehhez meg kell adnia a véletlenszerű országok nevét. Írja be az országot a beviteli mezőbe, és nyomja meg az Enter billentyűt. Ez az ország megjelenik a térképen, és attól függően változik a színe, hogy milyen közel van a rejtett országhoz. Minél sötétebb a szín, annál közelebb van a válaszhoz!`,
  help2: `Nézd meg a játék példáját. Tegyük fel, hogy Japán ország van elrejtve a játékban. Akkor ezek az országok ilyen színekre lesznek festve.`,
  help3: `Naponta egyszer egy új rejtett ország érhető el. Vagy váltson szabad módba a beállításokban, és játsszon korlátlanul.`,
  France: "Franciaország",
  Nepal: "Nepál",
  Mongolia: "Mongólia",
  "South Korea": "Dél-Korea",
  Aux1: `<b>A kezdéshez ["kattintson", "érintse meg"]</b> a földgömbre!`,
  Loading: "Várni rá...",
  GameTitle: "Játszma, meccs",
  Game1: "Ide írja be az ország nevét",
  Game2: "Enter",
  Game3: "Írjon be egy véletlenszerű országnevet, és nyomja meg az Enter billentyűt a kezdéshez",
  Game4: `Pörgesd, <span>["kattints", "érintsd meg"]</span>, és nagyítsd ki a földgömböt, hogy megtaláld a következő országot, amelyet kitalálhatsz`,
  Game5: "Nem ismerjük ezt az országot",
  Game6: "Ez az ország már belépett",
  Game7: "A Rejtett Ország az {answer} volt!",
  Game8: "Legközelebbi határ",
  StatsTitle: "Statisztika",
  Stats1: "Utolsó győzelem",
  Stats2: "A mai tippek",
  Stats3: "Megnyert játékok",
  Stats4: "Aktuális sorozat",
  Stats5: "Max sorozat",
  Stats6: "Átlagos találgatások",
  Stats7: "Átlagos találgatások",
  Stats8: "Visszaállítás",
  Stats9: "Részvény",
  Stats10: "Biztosan visszaállítja pontszámát?",
  Stats11: "A statisztikák törölve.",
  Stats12: "Vágólapra másolva!",
  SettingsTitle: "Beállítások",
  Settings1: "Napi téma",
  Settings2: "Éjszakai téma",
  Settings3: "Színvak mód",
  Settings4: "Színvak mód",
  Settings5: "Országok",
  Settings7: "Nyelv",
  Settings9: "Szabad mód",
  Settings10: "Tippek",
  Answer: "Válasz",
  Closest: "Legközelebb",
  Guessed: "Kitalálta",
  PracticeMode: "Ön szabad módban van.",
  PracticeExit: "Lépjen ki a szabad módból",
  PracticeNew: "Új ingyenes játék",
  PlayAgain: "Játszd újra",
  SortBy: "Sorrend:",
  SortByGuesses: "találgatások",
  SortByDistance: "távolság",
  Clipboard: "🌍🌍🌍\nA mai Globle rejtett országát {X} találgatásban sejtettem\nMeg tudod csinálni jobban?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Győzelem",
  Guesses: "Találgatások",
  GuessesFlags: "A tippjeid itt lesznek",
  Daily: "Napi",
  NextDailyIn: "Következő naponta",
  Learn: "Ismerje meg ezt az országot"
};